import { TOUR_TRANSLATIONS } from "../translations"

export const getProductPageKpiSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="pp-kpi-filters"]',
            title: t.ppKpiFilters.title,
            content: t.ppKpiFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="pp-kpi-table"]',
            title: t.ppKpiTable.title,
            content: t.ppKpiTable.content,
        },
        {
            target: '[data-tour="pp-kpi-create-report"]',
            title: t.ppKpiCreateReport.title,
            content: t.ppKpiCreateReport.content,
        },
    ]
}
